import { Module } from "vuex";
import { RootState } from "@/store/types";
import { emailStatistic } from "./statistic";

export const emailModule: Module<{modules: any}, RootState> = {
  modules: {
    emailStatistic,

  },
};